<template>
    <v-layout align-center justify-space-between class="pa-3">
        <v-btn
            data-testid="stepper-cancel-btn"
            class="stepper-cancel-btn error"
            v-if="canCancel"
            large
            @click.native="backToTenant"
        >
            Cancel
        </v-btn>
        <v-btn
            data-testid="stepper-prior-step-btn"
            class="stepper-prior-step-btn error"
            v-if="canReturnPriorStep"
            large
            :disabled="loading"
            @click.native="priorStep"
        >
            Back
        </v-btn>
        <v-btn
            data-testid="stepper-next-step-btn"
            class="stepper-next-step-btn primary"
            :disabled="!canGoNextStep"
            v-if="canShowNextButton"
            large
            @click.native="nextStep"
        >
            Next
        </v-btn>
        <v-btn
            data-testid="stepper-submit-btn"
            class="stepper-submit-btn primary"
            v-if="canSubmit"
            large
            :loading="loading"
            @click.native="submit"
        >
            Submit
        </v-btn>
        <v-btn
            data-testid="stepper-back-to-tenant-btn"
            class="stepper-back-to-tenant-btn teal darken-2 white--text"
            v-if="canFinish"
            large
            @click.native="backToTenant"
        >
            Back to Tenant
        </v-btn>
        <v-btn
            data-testid="stepper-finish-btn"
            class="stepper-finish-btn primary"
            v-if="canFinish"
            large
            @click.native="completeDisposition"
        >
            Finish
        </v-btn>
    </v-layout>
</template>

<script>
/* eslint-disable no-mixed-operators */
import { mapGetters, mapState } from "vuex";
export default {
  name: "StepperNavButtons",

  props: {
    loading: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    nextStep() {
      this.$emit("nextStep");
    },
    priorStep() {
      this.$emit("priorStep");
    },
    completeDisposition() {
      this.$emit("openDisposition");
    },
    submit() {
      this.$emit("submit");
    },
    backToTenant() {
      this.$emit("backToTenant");
    }
  },

  computed: {
    ...mapState({
      currentStep: state => state.application.currentStep,
      promiseDate: state => state.accountsReceivable.promiseDate
    }),

    ...mapGetters({
      selectedPaymentPlan: "selectedPaymentPlan",
      selectedPromiseToPay: "selectedPromiseToPay"
    }),

    promiseToPay() {
      return this.$route.name === "promiseToPay";
    },

    canCancel() {
      return this.currentStep === 1;
    },

    canReturnPriorStep() {
      if (!this.promiseToPay) {
        return this.currentStep >= 2 && this.currentStep < 3;
      } else {
        return this.currentStep >= 2 && this.currentStep < 4;
      }
    },

    canSubmit() {
      return !this.promiseToPay && this.currentStep === 2 || this.promiseToPay && this.currentStep === 3;
    },

    canGoNextStep() {
      return this.promiseCanGoNextStep || this.paymentPlanCanGoNextStep;
    },

    canShowNextButton() {
      if (!this.promiseToPay) {
        return this.currentStep >= 0 && this.currentStep <= 1;
      } else {
        return this.currentStep >= 0 && this.currentStep <= 2;
      }
    },

    promiseCanGoNextStep() {
      if (this.promiseToPay && this.currentStep < 3) {
        if (this.currentStep === 1 && this.selectedPromiseToPay !== undefined) {
          return true;
        } else if (this.currentStep === 2 && this.promiseDate !== "") {
          return true;
        }
      }
      return false;
    },

    paymentPlanCanGoNextStep() {
      if (!this.promiseToPay) {
        return this.currentStep < 2 &&
          this.selectedPaymentPlan &&
          this.selectedPaymentPlan.unit_name !== undefined;
      }
      return false;
    },

    canFinish() {
      return !this.promiseToPay && this.currentStep === 3 || this.promiseToPay && this.currentStep === 4;
    }
  }
};
</script>
